import Icon from '@components/common/Icon';

const PassionSection = () => {
  const passions = [
    {
      icon: 'chess',
      title: 'Chess: The Art of Strategy',
      description: `Chess taught me that every decision has consequences, every move shapes the future.
        It's not just about winning games—it's about developing mental discipline, pattern recognition,
        and the ability to think multiple steps ahead. Through chess, I've learned patience, resilience,
        and the importance of continuous improvement. Competing internationally and earning the National
        Master title has shown me that dedication and strategic thinking can overcome any challenge.`,
      color: 'var(--color-accent-5)',
    },
    {
      icon: 'robotics',
      title: 'Robotics: Building the Future',
      description: `Robotics represents the perfect blend of creativity and engineering. Leading my robotics
        team through FRC and VEX competitions taught me that innovation happens when diverse minds collaborate
        toward a common goal. From designing mechanical systems to programming autonomous functions, every challenge
        reinforces problem-solving skills that extend far beyond the workshop. Winning the Rookie Inspiration Award
        at FRC Sydney 2024 validated our team's commitment to inspiring others through STEM excellence.`,
      color: 'var(--color-accent-6)',
    },
    {
      icon: 'social-impact',
      title: 'Social Impact: Giving Back',
      description: `True success is measured not by personal achievements, but by the positive impact we create
        in others' lives. Teaching chess to prison inmates in the Philippines opened my eyes to the transformative
        power of mentorship and education. Whether raising over $4,000 for underprivileged students, mentoring
        100+ youth in robotics and chess, or working with street animals in Kolkata, every initiative reinforces
        my belief that we have a responsibility to lift others as we climb.`,
      color: 'var(--color-accent-7)',
    },
  ];

  return (
    <section
      className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: 'var(--color-theme-1)' }}
    >
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8 sm:mb-12">
          <h2
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-3 sm:mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            What Drives Me
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Three pillars that define my purpose and guide my journey forward.
          </p>
        </div>

        {/* Mobile: horizontal scroll, Desktop: vertical stack */}
        <div className="md:space-y-8 flex md:flex-col overflow-x-auto gap-4 md:gap-0 snap-x snap-mandatory scrollbar-hide pb-4 md:pb-0 -mx-4 px-4 md:mx-0">
          {passions.map((passion, index) => (
            <div
              key={index}
              className="p-6 sm:p-8 rounded-lg transition-all duration-300 hover:shadow-card-hover flex-shrink-0 w-[90vw] md:w-auto snap-center"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'var(--color-card-border)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-hover-border)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-border)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start">
                {/* Icon */}
                <div
                  className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-xl flex items-center justify-center"
                  style={{
                    backgroundColor: passion.color,
                  }}
                >
                  <Icon name={passion.icon} size="lg" className="sm:hidden" style={{ color: 'white' }} />
                  <Icon name={passion.icon} size="xl" className="hidden sm:block" style={{ color: 'white' }} />
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3
                    className="text-xl sm:text-2xl font-bold mb-2 sm:mb-3"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {passion.title}
                  </h3>
                  <p
                    className="leading-relaxed text-sm sm:text-base"
                    style={{ color: 'var(--color-subtle)' }}
                  >
                    {passion.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PassionSection;
